import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { styled } from '@mui/styles';
import { useFormikContext } from 'formik';
import { ClaimsFormVM } from 'front-office/view-models/claims/claims-form';
import PaymentCertificate from 'front-office/components/shared/payment';
import ClaimsAnpr from './claims';
import { useCallback } from 'react';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

interface ModalCertificateProps {
  open: boolean;
  onClose: (open: boolean) => void;
}

const ModalCertificate = ({ open, onClose }: ModalCertificateProps): React.ReactElement => {
  const formContext = useFormikContext<ClaimsFormVM>();

  const resetOnClose = useCallback(() => {
    formContext.setValues({
      ...formContext.values,
      claims: null,
      citizenUE: false,
      modality: null,
      typePayment: '',
      dateForm: null,
    });
    onClose(false);
  }, [onClose, formContext.values, formContext.setValues]);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="primary" color="white">
        Richiesta Attestazione
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <ClaimsAnpr />
        <PaymentCertificate />
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="contained"
          color="primary"
          type="button"
          onClick={() => formContext.handleSubmit()}
        >
          Richiesta Attestazione
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrand" type="button" onClick={resetOnClose}>
          Chiudi
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalCertificate.displayName = 'Modal request certificate';

export default ModalCertificate;
